import { View, Text, StyleSheet, FlatList, TouchableOpacity, Platform } from 'react-native'
import React, { useEffect, useState } from 'react'
import TopGreenHeader from '../Common/TopGreenHeader'
import { useNavigation } from '@react-navigation/native'
import { useDispatch, useSelector } from 'react-redux'
import { getAllAddressCreator } from '../../slices/authSlice'
import { toTitleCase } from '../Common/helper';

export default function SelectTransport() {
    const dispatch = useDispatch()
    const navigation = useNavigation()
    const selectedAddressData = useSelector(state => state.auth.selectedAddress)
    const [selectedAddress, setSelectedAddress] = useState([])


    useEffect(() => {
        if (!selectedAddressData?.length) return
        const seen = new Set()
        const unique = selectedAddressData.filter((item) => {
            const key = `${item.houseno}-${item.area}-${item.city}-${item.zipcode}`
            if (seen.has(key)) return false
            seen.add(key)
            return true
        })
        setSelectedAddress(unique)
    }, [selectedAddressData])

    const selectAddressButton = () => {
        dispatch(getAllAddressCreator())
        navigation.navigate("SelectAddressScreen")
    }
    const handleSave = () => {
        navigation.navigate("ConfirmBooking")
    }
    return (
        <View style={{ flex: 1 }}>
            <TopGreenHeader Heading={'Select Transport'} navigation={navigation} isBackIcon={true} isNotification={false} />
            {/* <Text style={style.header}> Add Addresses</Text> */}
            <View style={style.buttonContainer}>
                <TouchableOpacity style={style.addButton} onPress={() => selectAddressButton()}>
                    <Text style={style.addButtonText}>Tap to Select Address</Text>
                </TouchableOpacity>
            </View>
            <TouchableOpacity>
                <Text style={{ fontFamily: 'FacebookSansBold', textAlign: 'center', fontSize: 13, color: '#505766', width: '90%', alignSelf: 'center' }}>
                    Tap here, if you want the location to be Danilees Center
                </Text>
            </TouchableOpacity>
            {selectedAddress?.length > 0 && (
                <>
                    <View style={style.container}>
                        <FlatList
                            data={selectedAddress}
                            keyExtractor={(item, index) => index.toString()}
                            renderItem={({ item }) => (
                                <TouchableOpacity
                                    style={style.addressItem}
                                >
                                    <Text style={style.addressText}>
                                        {`${toTitleCase(item.tag)} - ${item.houseno ? item.houseno + ',' : ''} ${toTitleCase(item.area)}, ${toTitleCase(item.city)}, ${item.zipcode}`}
                                    </Text>
                                </TouchableOpacity>
                            )}
                        />
                    </View>
                    <View style={style.buttonContainer}>
                        <TouchableOpacity style={style.addButton} onPress={() => handleSave()}>
                            <Text style={style.addButtonText}>Save</Text>
                        </TouchableOpacity>
                    </View>
                </>
            )}

        </View>
    )
}
const style = StyleSheet.create({
    header: {
        fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
        fontStyle: "normal",
        fontSize: 22,
        fontWeight: 'bold',
        marginVertical: 20,
        textAlign: 'center'
    },
    greyText: {
        marginVertical: 10,
        fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
        fontStyle: "normal",
        fontWeight: 'bold',
        textAlign: 'center',
        color: "grey",
    },
    buttonContainer: {
        alignItems: 'center',
        marginTop: 16,
    },
    addButton: {
        backgroundColor: '#A3D900',
        paddingVertical: 16,
        paddingHorizontal: 24,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        width: '60%', // Adjust width to avoid stretching
        marginBottom: 12, // Adds spacing between buttons

    },
    addButtonText: {
        fontSize: 16,
        fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
        fontStyle: "normal",
        fontWeight: 'bold',
        color: '#fff',
    },
    container: {
        flex: 1,
        padding: 20,
        // backgroundColor: '#fff',
    },
    title: {
        fontSize: 22,
        fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
        fontWeight: '600',
        marginBottom: 20,
        textAlign: 'center',
    },
    addressItem: {
        paddingVertical: 15,
        borderBottomWidth: 1,
        borderColor: '#ccc',
    },
    addressText: {
        fontSize: 16,
        color: '#000',
        lineHeight: 20,
        fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
        fontStyle: "normal",
    },
})